import React from 'react';
import { Box, makeStyles } from '@material-ui/core';

import { ContainerSection } from '../../../shared/components/ContainerSection';
import { WorkWithItem } from '../WorkWith/WorkWithItem';
import { WORK_WITH_DATA } from './workWithData';
import { Divider } from '../../../shared/components/Divider';

const useStyle = makeStyles(theme => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: '20px',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'repeat(1, 1fr)',
    },
  },
}));

export const WorkWith = () => {
  const classes = useStyle();
  return (
    <ContainerSection position="top" anchor="#" title="Lavorato">
      <Divider height={70} />
      <Box component="div" className={classes.grid}>
        {WORK_WITH_DATA.map(({ title, subTitle }, i) => (
          <WorkWithItem key={i} title={title} subTitle={subTitle} />
        ))}
      </Box>
    </ContainerSection>
  );
};
